/**
 * to create string from test to t|te|tes|test
 * @param term
 * @returns
 */
export const queryString = (term) => {
    const results = {};
    term.split('').forEach((_, index) => {
        for (let j = 0; j < index; j++) {
            const sub = term
                .substring(j, index + 1)
                .replace(/[.*+\-?^${}()|[\]\\\s/]/g, '');
            results[sub] = sub;
        }
    });
    const termsArray = Object.values(results)
        .filter((n) => n.length > 1)
        .sort((a, b) => b.length - a.length);
    return termsArray.join('|');
};
/**
 * retuns custom escaped string based on stringValue
 * to match all characters inclusing special characters
 */
export const queryEscapedString = (stringValue) => {
    const escapedString = stringValue.replace(/[.*?^${}()|[\]\\]/g, '\\$&');
    return escapedString;
};
